import HealthLevels from './HealthLevels';

export default {
  [HealthLevels.NA]: 'NA',
  [HealthLevels.GO]: 'Go',
  [HealthLevels.SLOW]: 'Slow',
  [HealthLevels.WHOA]: 'Whoa!'
};
